import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getStateById, defaultStateData, updateState, createState } from '@/api/locations/states';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.listQuery = {
      page: 1,
      limit: 10,
      sort: 'name,ASC'
    };
    this.formData = Object.assign({}, defaultStateData);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter name',
        trigger: 'blur'
      }, {
        min: 3,
        max: 50,
        message: 'Length should be 3 to 50',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultStateData);
      this.formData.countryId = parseInt(this.$route.params && this.$route.params.countryId);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getStateById(id);
      this.formData = data;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        this.formData.country = {
          id: this.formData.countryId
        };
        await updateState(this.formData.id, this.formData);
      } else {
        delete this.formData.country;
        await createState(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'State saved',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/states/list',
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'StateDetail',
  components: {}
})], default_1);
export default default_1;